import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "device-add-edit-card__title fw-bold" }
const _hoisted_4 = {
  key: 0,
  class: "device-add-edit-card__slots"
}
const _hoisted_5 = { class: "device-add-edit-card__actions d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "channels-container"
}
const _hoisted_7 = { class: "list-unstyled mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeviceSlotsListOverview = _resolveComponent("DeviceSlotsListOverview")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_SlotListItem = _resolveComponent("SlotListItem")

  return (_openBlock(), _createBlock("div", {
    class: ["device-add-edit-card", { 'is--expanded': _ctx.isExpanded }]
  }, [
    _createVNode(_component_Card, null, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.device.model) + " - ID " + _toDisplayString(_ctx.device.id), 1),
            (!_ctx.isOnlyDeviceSelection)
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode(_component_DeviceSlotsListOverview, {
                    isAdd: _ctx.isAdd,
                    device: _ctx.device,
                    slotList: _ctx.compatibleSlots,
                    linkableObject: _ctx.linkableObject,
                    ruleServiceType: _ctx.ruleServiceType
                  }, null, 8, ["isAdd", "device", "slotList", "linkableObject", "ruleServiceType"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_5, [
            (_ctx.isAdd)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "p-button-rounded p-button-outlined py-1",
                  onClick: _ctx.addDevice
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isSingleDeviceSelection)
                      ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                          key: 0,
                          src: 
                                    require(`@/assets/images/icons/icon-add-circle-outline.svg`)
                                ,
                          class: "mr-1"
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(
                                    !_ctx.isSingleDeviceSelection
                                        ? "AppResource.Add"
                                        : "general.select"
                                )), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "p-button-text py-1",
                  onClick: _ctx.removeDevice
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Remove")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])),
            (!_ctx.isOnlyDeviceSelection)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  class: "p-button-text ml-2 expand-btn",
                  onClick: _ctx.toggleExpand
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InlineSvgScoped, {
                      src: 
                                    require(`@/assets/images/icons/icon-arrows-down.svg`)
                                
                    }, null, 8, ["src"])
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }),
    (!_ctx.isOnlyDeviceSelection)
      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("ul", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.compatibleSlots, (slot) => {
              return (_openBlock(), _createBlock(_component_SlotListItem, {
                key: slot,
                objectSlot: slot,
                isAdd: _ctx.isAdd,
                device: _ctx.device,
                linkableObject: _ctx.linkableObject,
                ruleServiceType: _ctx.ruleServiceType,
                "show-bar": slot.showBar
              }, null, 8, ["objectSlot", "isAdd", "device", "linkableObject", "ruleServiceType", "show-bar"]))
            }), 128))
          ])
        ], 512)), [
          [_vShow, _ctx.isExpanded]
        ])
      : _createCommentVNode("", true)
  ], 2))
}